import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const SCRAMBLE = "ENERGYMATCHER—◇▲△○◯◐◑◒◓";

export default function Loader() {
    const [done, setDone] = useState(false);
    const [text, setText] = useState("");

    useEffect(() => {
        const target = "ENERGY MATCHER";
        let frame = 0;
        const total = 28;
        const id = setInterval(() => {
            frame += 1;
            let out = "";
            for (let i = 0; i < target.length; i++) {
                if (frame >= total) {
                    out += target[i];
                } else if (frame > i * 1.6) {
                    out += target[i];
                } else {
                    out +=
                        target[i] === " "
                            ? " "
                            : SCRAMBLE[
                                  Math.floor(Math.random() * SCRAMBLE.length)
                              ];
                }
            }
            setText(out);
            if (frame >= total) {
                clearInterval(id);
                setTimeout(() => setDone(true), 550);
            }
        }, 55);

        return () => clearInterval(id);
    }, []);

    return (
        <AnimatePresence>
            {!done && (
                <motion.div
                    initial={{ y: 0 }}
                    exit={{ y: "-101%" }}
                    transition={{
                        duration: 0.9,
                        ease: [0.7, 0, 0.3, 1],
                    }}
                    className="fixed inset-0 z-[200] bg-black flex items-center justify-center grain"
                    data-testid="page-loader"
                >
                    <div className="text-center">
                        <p className="label-mono mb-4 text-white/40">
                            FW / 25 · Loading
                        </p>
                        <h1 className="font-display text-5xl md:text-7xl uppercase tracking-tighter font-black tabular-nums">
                            {text || "\u00A0"}
                        </h1>
                        <div className="mt-8 mx-auto h-px w-32 bg-white/15 overflow-hidden">
                            <motion.div
                                className="h-full bg-white"
                                initial={{ width: 0 }}
                                animate={{ width: "100%" }}
                                transition={{ duration: 1.6, ease: "easeInOut" }}
                            />
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
